import { Toast } from "vant";

class Response {

  static CallResponse(response, callback) {
    if (response.Code == 200) {
      if (response.Result.IsSuccess) {
        Toast.success(response.Result.Message);
      } else {
        Toast.fail(response.Result.Message);
      }
      callback(response.Result);
    } else {
      Toast.fail("请求出错！");
    }
  }

  static callNotMsgResponse = (response, callback) => {
    // console.log(response);
    if (response.Code == 200) {
      callback(response.Result);
    } else {
      Toast.fail(response.Result.Message);
    }
  };

}

export default Response;
